import React from 'react';
import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';
import { LoadingOutlined } from '@ant-design/icons';
// Local Deps

import { Steps, Modal, Button } from 'antd';

import { Row, Col } from 'reactstrap';
import './Registration.scss';

// import RegistrationHOC from './RegistrationHOC';
// Local Deps
import CollectCage from './subComponents/CollectCage';
import UserInfo from './subComponents/UserInfo';
import CollectProcurmentAgency from './subComponents/CollectProcurmentAgency';

import OrgInfo from './subComponents/OrgInfo';
import Summary from './subComponents/Summary';
import InitialRequest from './subComponents/InitialRequest';
import FindOrganization from './subComponents/FindOrganization';
import Toast from '../../components/Toaster';
// import PocSelect from './subComponents/PocSelect';
import OrgDescription from './subComponents/OrgDescription/OrgDescription';
// import Loading from '../../components/Loading';

class Registration extends React.Component {
  static propTypes = {
    // functions
    onChange: PropTypes.func.isRequired,
    changeOrg: PropTypes.func.isRequired,
    handleOk: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    toastLevel: PropTypes.string,
    toastMessage: PropTypes.string,
    showToast: PropTypes.bool.isRequired,
    onOrganizationChange: PropTypes.func.isRequired,
    onCountryChange: PropTypes.func.isRequired,
    currentFlow: PropTypes.string.isRequired,
    cage: PropTypes.string,
    orgExists: PropTypes.bool.isRequired,
    email: PropTypes.string,
    orgType: PropTypes.number.isRequired,
    orgAdmin: PropTypes.bool.isRequired,
    step: PropTypes.number.isRequired,
    orgStep: PropTypes.number.isRequired,
    userExists: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    steps: PropTypes.array.isRequired,
    phone: PropTypes.string,
    // selectedPoc: PropTypes.string.isRequired,
    verifying: PropTypes.bool.isRequired,
    organization: PropTypes.any.isRequired,
    counter: PropTypes.number.isRequired,
    setRegistatrationFlow: PropTypes.func.isRequired,
    continueWithoutCage: PropTypes.bool.isRequired,
    continueWithoutRFQ: PropTypes.bool.isRequired,
    organizationList: PropTypes.any.isRequired,
    OnFoundOrganizationChange: PropTypes.func.isRequired,
    procurementGroupList: PropTypes.any.isRequired,
    onProcurementGroupChange: PropTypes.func.isRequired,
    inputProcGrp: PropTypes.string.isRequired,

    onMultiSelectOrganization: PropTypes.func.isRequired,
    industryAssociationsList: PropTypes.any.isRequired,
    naicsCastingCodesList: PropTypes.any.isRequired,
    naicsMachineCodesList: PropTypes.any.isRequired,
    industryTypesList: PropTypes.any.isRequired,
    reasonRegistration: PropTypes.string.isRequired,
    closeModalFailedRegistration: PropTypes.func.isRequired,
    finalSubmit: PropTypes.string,
  };

  static defaultProps = {
    phone: '',
    cage: '',
    email: '',
    toastLevel: 'success',
    toastMessage: 'Default Props',
    finalSubmit: undefined,
  };



  HeaderManagement = () => {
    if (this.props.step === 0) {
      return 'Registration Type';
    }
    switch (this.props.currentFlow) {
      case 'new':
        switch (this.props.step) {
          case 1:
            return 'CAGE Code';
          case 2:
            return 'Contact Information';
          case 3:
            if (this.props.continueWithoutCage) {
              switch (this.props.orgStep) {
                case 1:
                  return 'Create Your Organization';
                case 2:
                  return 'Describe Your Organization';
                default:
                  return 'Create Your Organization';
              }
            }
            else return 'Describe Your Organization';
          case 4:
            return 'Verify Information and Submit';

          default:
            return 'here';
        }
      case 'industry':
        switch (this.props.step) {
          case 1:
            return 'Find your Organization';
          case 2:
            return 'Contact Information';

          case 3:
            return 'Verify Information and Submit';

          default:
            return 'here';
        }
      // case 'gov-without-procurement':
      //   switch (this.props.step) {
      //     case 1:
      //       return 'Contact Information';

      //     case 2:
      //       return 'Verify Information and Submit';

      //     default:
      //       return 'here';
      //   }

      case 'gov':
        switch (this.props.step) {
          case 1:
            return 'Select your Agency RFQ Group';
          case 2:
            return 'Contact Information';

          case 3:
            return 'Verify Information and Submit';

          default:
            return 'here';
        }

      default:
        return 'here';
    }
  };

  SubHeaderManagement = () => {
    if (this.props.step === 0) {
      return 'Your ICON level of access will be determined by your Government Authorization. Please select the registration type that best describes you.';
    }

    switch (this.props.currentFlow) {
      case 'new':
        switch (this.props.step) {
          case 1:
            return 'Does your organization have a verified CAGE Code on SAM.gov?';
          case 2:
            // if (this.props.continueWithoutCage) {
            //   return 'Please enter your contact information. Note that the email address you provide will be your user ID used to log in the portal.';
            // }
            // return 'Please select the appropriate SAM.gov POC for your Organization. Note you must have access to the email address you select to log into the ICON Portal.';
            return 'Please enter your contact information. Note that the email address you provide will be your user ID used to log in the portal.';

          case 3:
            if (this.props.continueWithoutCage) {
              switch (this.props.orgStep) {
                case 1:
                  return 'Please enter your organization name and address';
                case 2:
                  return 'Please enter your Organization Type, NAICS and Industry Associations';
                default:
                  return 'Please enter your organization name and address';
              }
            }
            else return 'Industry Type and NAICS Codes derived from your SAM.gov account. Please select applicable Industry Association Memberships.';

          case 4:
            return this.props.continueWithoutCage ? 'Your request will be viewed and approved by the appropriate admins' : 'Your Request will be viewed and approved by the appropriate admins.  If any of this information is incorrect please correct it in SAM.gov.';

          default:
            return 'here';
        }
      case 'industry':
        switch (this.props.step) {
          case 1:
            return 'Please select your organization from the drop-down list:';

          case 2:
            return 'Please enter your contact information. Note that the email address you provide will be your user ID used to log in the portal.';
          case 3:
            return 'Your request will be reviewed. Upon approval, you will recieve an email with instructions for logging into the ICON Portal';

          default:
            return 'here';
        }
      // case 'gov-without-procurement':
      //   switch (this.props.step) {
      //     case 1:
      //       return 'Please enter your contact information. Note that the email address you provide will be your user ID used to log in the portal.';
      //     case 2:
      //       return 'Your request will be viewed and approved by the appropriate admins';

      //     default:
      //       return 'here';
      //   }
      case 'gov':
        switch (this.props.step) {
          case 1:
            return 'Please select your Government RFQ Group from the dropdown list. If you don’t find your RFQ Group in the list, type in a new Group Name and a new group will be created. You can also continue without RFQ Group';
          case 2:
            return 'Please enter your contact information. Note that the email address you provide will be your user ID used to log in the portal.';
          case 3:
            return 'Your request will be viewed and approved by the appropriate admins';

          default:
            return 'here';
        }
      default:
        return 'here';
    }
  };

  RouteManagement = () => {
    if (this.props.step === 0) {
      return (
        <InitialRequest
          onCancel={this.props.onCancel}
          onSubmit={this.props.onSubmit}
          currentFlow={this.props.currentFlow}
          setRegistatrationFlow={this.props.setRegistatrationFlow}
        />
      );
    }
    switch (this.props.currentFlow) {
      case 'new':
        switch (this.props.step) {
          case 1:
            return (
              <CollectCage
                continueWithoutCage={this.props.continueWithoutCage}
                onChange={this.props.onChange}
                onCancel={this.props.onCancel}
                onSubmit={this.props.onSubmit}
                cage={this.props.cage}
                email={this.props.email}
              />
            );

          case 2:
            // if (this.props.continueWithoutCage) {
            //   return (
            //     <UserInfo
            //       onChange={this.props.onChange}
            //       onSubmit={this.props.onSubmit}
            //       onCancel={this.props.onCancel}
            //       cage={this.props.cage}
            //       email={this.props.email}
            //       orgType={this.props.orgType}
            //       name={this.props.name}
            //       phone={this.props.phone}
            //       changeOrg={this.props.changeOrg}
            //       organization={this.props.organization}
            //       userExists={this.props.userExists}
            //     />
            //   );
            // }
            // return (
            //   <PocSelect
            //     onChange={this.props.onChange}
            //     onSubmit={this.props.onSubmit}
            //     onCancel={this.props.onCancel}
            //     cage={this.props.cage}
            //     email={this.props.email}
            //     orgType={this.props.orgType}
            //     name={this.props.name}
            //     phone={this.props.phone}
            //     selectedPoc={this.props.selectedPoc}
            //     changeOrg={this.props.changeOrg}
            //     organization={this.props.organization}
            //     userExists={this.props.userExists}
            //   />
            // );
            return (
              <UserInfo
                onChange={this.props.onChange}
                onSubmit={this.props.onSubmit}
                onCancel={this.props.onCancel}
                cage={this.props.cage}
                email={this.props.email}
                orgType={this.props.orgType}
                name={this.props.name}
                phone={this.props.phone}
                changeOrg={this.props.changeOrg}
                organization={this.props.organization}
                userExists={this.props.userExists}
              />
            );



          case 3:
            if (this.props.continueWithoutCage) {
              switch (this.props.orgStep) {
                case 1:
                  return (
                    <OrgInfo
                      onOrganizationChange={this.props.onOrganizationChange}
                      onCountryChange={this.props.onCountryChange}
                      onSubmit={this.props.onSubmit}
                      cage={this.props.cage}
                      onCancel={this.props.onCancel}
                      email={this.props.email}
                      orgAdmin={this.props.orgAdmin}
                      userExists={this.props.userExists}
                      organization={this.props.organization}
                    />
                  );
                case 2:
                  return (
                    <OrgDescription
                      onChange={this.props.onChange}
                      onSubmit={this.props.onSubmit}
                      onCancel={this.props.onCancel}
                      onMultiSelectOrganization={this.props.onMultiSelectOrganization}
                      cage={this.props.cage}
                      organization={this.props.organization}
                      industryAssociationsList={this.props.industryAssociationsList}
                      naicsCastingCodesList={this.props.naicsCastingCodesList}
                      naicsMachineCodesList={this.props.naicsMachineCodesList}
                      industryTypesList={this.props.industryTypesList}
                      reasonRegistration={this.props.reasonRegistration}
                    />
                  );
                default:
                  return (
                    <OrgInfo
                      onOrganizationChange={this.props.onOrganizationChange}
                      onCountryChange={this.props.onCountryChange}
                      onSubmit={this.props.onSubmit}
                      cage={this.props.cage}
                      onCancel={this.props.onCancel}
                      email={this.props.email}
                      orgAdmin={this.props.orgAdmin}
                      userExists={this.props.userExists}
                      organization={this.props.organization}
                    />
                  );
              }
            }
            else return (
              <OrgDescription
                onChange={this.props.onChange}
                onSubmit={this.props.onSubmit}
                onCancel={this.props.onCancel}
                onMultiSelectOrganization={this.props.onMultiSelectOrganization}
                cage={this.props.cage}
                organization={this.props.organization}
                industryAssociationsList={this.props.industryAssociationsList}
                naicsCastingCodesList={this.props.naicsCastingCodesList}
                naicsMachineCodesList={this.props.naicsMachineCodesList}
                industryTypesList={this.props.industryTypesList}
                reasonRegistration={this.props.reasonRegistration}
              />
            );


          case 4:
            return (
              <Summary
                onChange={this.props.onChange}
                onSubmit={this.props.onSubmit}
                cage={this.props.cage}
                continueWithoutCage={this.props.continueWithoutCage}
                currentFlow={this.props.currentFlow}
                onCancel={this.props.onCancel}
                email={this.props.email}
                userExists={this.props.userExists}
                organization={this.props.organization}
                name={this.props.name}
                phone={this.props.phone}
                orgAdmin={this.props.orgAdmin}
                orgType={this.props.orgType}
                orgExists={this.props.orgExists}
                closeModalFailedRegistration={this.props.closeModalFailedRegistration}
                finalSubmit={this.props.finalSubmit}
              />
            );
          default:
            return (
              <Summary
                onChange={this.props.onChange}
                onSubmit={this.props.onSubmit}
                cage={this.props.cage}
                continueWithoutCage={this.props.continueWithoutCage}
                currentFlow={this.props.currentFlow}
                onCancel={this.props.onCancel}
                email={this.props.email}
                userExists={this.props.userExists}
                organization={this.props.organization}
                name={this.props.name}
                phone={this.props.phone}
                orgAdmin={this.props.orgAdmin}
                orgType={this.props.orgType}
                orgExists={this.props.orgExists}
                closeModalFailedRegistration={this.props.closeModalFailedRegistration}
                finalSubmit={this.props.finalSubmit}
              />
            );
        }

      case 'industry':
        switch (this.props.step) {
          case 1:
            return (
              <FindOrganization
                onSubmit={this.props.onSubmit}
                onCancel={this.props.onCancel}
                onChange={this.props.OnFoundOrganizationChange}
                cage={this.props.cage}
                email={this.props.email}
                orgType={this.props.orgType}
                name={this.props.name}
                phone={this.props.phone}
                // changeOrg={this.props.changeOrg}
                organization={this.props.organization}
                userExists={this.props.userExists}
                organizationList={this.props.organizationList}
              />
            );
          case 2:
            return (
              <UserInfo
                onChange={this.props.onChange}
                onSubmit={this.props.onSubmit}
                onCancel={this.props.onCancel}
                cage={this.props.cage}
                email={this.props.email}
                orgType={this.props.orgType}
                name={this.props.name}
                phone={this.props.phone}
                changeOrg={this.props.changeOrg}
                organization={this.props.organization}
                userExists={this.props.userExists}
              />
            );
          case 3:
            return (
              <Summary
                onChange={this.props.onChange}
                onSubmit={this.props.onSubmit}
                currentFlow={this.props.currentFlow}
                cage={this.props.cage}
                onCancel={this.props.onCancel}
                email={this.props.email}
                userExists={this.props.userExists}
                organization={this.props.organization}
                name={this.props.name}
                phone={this.props.phone}
                orgAdmin={this.props.orgAdmin}
                orgType={this.props.orgType}
                closeModalFailedRegistration={this.props.closeModalFailedRegistration}
                finalSubmit={this.props.finalSubmit}
              />
            );

          default:
            return (
              <Summary
                onChange={this.props.onChange}
                onSubmit={this.props.onSubmit}
                currentFlow={this.props.currentFlow}
                cage={this.props.cage}
                onCancel={this.props.onCancel}
                email={this.props.email}
                userExists={this.props.userExists}
                organization={this.props.organization}
                name={this.props.name}
                phone={this.props.phone}
                orgAdmin={this.props.orgAdmin}
                orgType={this.props.orgType}
                closeModalFailedRegistration={this.props.closeModalFailedRegistration}
                finalSubmit={this.props.finalSubmit}
              />
            );
        }
      // case 'gov-without-procurement':
      //   switch (this.props.step) {
      //     case 1:
      //       return (
      //         <UserInfo
      //           onChange={this.props.onChange}
      //           onSubmit={this.props.onSubmit}
      //           onCancel={this.props.onCancel}
      //           cage={this.props.cage}
      //           email={this.props.email}
      //           orgType={this.props.orgType}
      //           name={this.props.name}
      //           phone={this.props.phone}
      //           changeOrg={this.props.changeOrg}
      //           organization={this.props.organization}
      //           userExists={this.props.userExists}
      //         />
      //       );
      //     case 2:
      //       return (
      //         <Summary
      //           onChange={this.props.onChange}
      //           onSubmit={this.props.onSubmit}
      //           currentFlow={this.props.currentFlow}
      //           cage={this.props.cage}
      //           onCancel={this.props.onCancel}
      //           email={this.props.email}
      //           userExists={this.props.userExists}
      //           organization={this.props.organization}
      //           name={this.props.name}
      //           phone={this.props.phone}
      //           orgAdmin={this.props.orgAdmin}
      //           orgType={this.props.orgType}
      //         />
      //       );
      //     default:
      //       return (
      //         <Summary
      //           onChange={this.props.onChange}
      //           onSubmit={this.props.onSubmit}
      //           currentFlow={this.props.currentFlow}
      //           cage={this.props.cage}
      //           onCancel={this.props.onCancel}
      //           email={this.props.email}
      //           userExists={this.props.userExists}
      //           organization={this.props.organization}
      //           name={this.props.name}
      //           phone={this.props.phone}
      //           orgAdmin={this.props.orgAdmin}
      //           orgType={this.props.orgType}
      //         />
      //       );
      //   }
      case 'gov':
        switch (this.props.step) {
          case 1:
            return (
              <CollectProcurmentAgency
                onChange={this.props.onChange}
                onSelect={this.props.onProcurementGroupChange}
                onCancel={this.props.onCancel}
                onSubmit={this.props.onSubmit}
                cage={this.props.cage}
                email={this.props.email}
                continueWithoutRFQ={this.props.continueWithoutRFQ}
                organization={this.props.organization}
                procurementGroupList={this.props.procurementGroupList}
                inputProcGrp={this.props.inputProcGrp}
              />
            );
          case 2:
            return (
              <UserInfo
                onChange={this.props.onChange}
                onSubmit={this.props.onSubmit}
                onCancel={this.props.onCancel}
                cage={this.props.cage}
                email={this.props.email}
                orgType={this.props.orgType}
                name={this.props.name}
                phone={this.props.phone}
                changeOrg={this.props.changeOrg}
                organization={this.props.organization}
                userExists={this.props.userExists}
              />
            );
          case 3:
            return (
              <Summary
                onChange={this.props.onChange}
                onSubmit={this.props.onSubmit}
                currentFlow={this.props.currentFlow}
                continueWithoutRFQ={this.props.continueWithoutRFQ}
                cage={this.props.cage}
                onCancel={this.props.onCancel}
                email={this.props.email}
                userExists={this.props.userExists}
                organization={this.props.organization}
                name={this.props.name}
                phone={this.props.phone}
                orgAdmin={this.props.orgAdmin}
                orgType={this.props.orgType}
                closeModalFailedRegistration={this.props.closeModalFailedRegistration}
                finalSubmit={this.props.finalSubmit}
              />
            );
          default:
            return (
              <Summary
                onChange={this.props.onChange}
                onSubmit={this.props.onSubmit}
                currentFlow={this.props.currentFlow}
                cage={this.props.cage}
                onCancel={this.props.onCancel}
                email={this.props.email}
                userExists={this.props.userExists}
                organization={this.props.organization}
                name={this.props.name}
                phone={this.props.phone}
                orgAdmin={this.props.orgAdmin}
                orgType={this.props.orgType}
                closeModalFailedRegistration={this.props.closeModalFailedRegistration}
                finalSubmit={this.props.finalSubmit}
              />
            );
        }
      default:
        return 'here';
    }
  };


  render() {
    const {
      toastLevel,
      toastMessage,
      showToast,
      step,
      steps,
      counter,
      verifying,
      handleOk,
    } = this.props;

    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Registration Page</title>
        </Helmet>
        <div className="nf-registration">
          <Row>
            <div
              style={{
                width: '95vw',
                margin: 'auto',
                marginTop: '32px',
              }}
            >
              {steps && (
                <Steps current={step - 1}>
                  {steps.map((item, index) => (
                    <Steps.Step
                      key={item.title}
                      title={index === step - 1 ? item.title : ''}
                      icon={
                        verifying && index === step ? (
                          <LoadingOutlined />
                        ) : (
                          item.icon
                        )
                      }
                    />
                  ))}
                </Steps>
              )}
            </div>
          </Row>
          <Row>
            {/* <!-- HEADER --> */}

            <Col xs={1} />
            <Col>
              <h1 className="nf-registration__header">
                {this.HeaderManagement()}
              </h1>
              <p className="nf-registration__subheader">
                {this.SubHeaderManagement()}
              </p>
            </Col>
            {/* <!-- ADD USER BUTTON --> */}
          </Row>
          <div>{this.RouteManagement()}</div>
        </div>
        <Toast level={toastLevel} message={toastMessage} visible={showToast} />
        <Modal
          visible={counter === 3}
          title="Having trouble Registering?"
          onOk={handleOk}
          onCancel={handleOk}
          centered
          footer={[
            <Button key="submit" type="primary" onClick={handleOk}>
              Try Again?
            </Button>,
          ]}
        >
          <p>
            Please verify that the information is correct and try again or
            contact{' '}
            <a
              href="mailto:support@nffs.org?Subject=Registration%20Help"
              target="_top"
            >
              {' '}
              support@nffs.org
            </a>{' '}
            for assistance.
          </p>
        </Modal>
      </div>
    );
  }
}

export default Registration;

// export default RegistrationHOC(Registration);



// WEBPACK FOOTER //
// ./src/pages/Registration/Registration.jsx